import getIn from 'transmute/getIn';
export const getAsyncPastConversations = getIn(['pastConversations']);